interface FormErrorProps {
  message?: string;
}

export function FormError({ message }: FormErrorProps) {
  if (!message) return null;
  return (
    <p className="text-xs text-[hsl(var(--destructive))]">{message}</p>
  );
}
